import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { AppCard } from "@/layout/AppComponents";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import ReactDOMServer from "react-dom/server";
import Translator from "../../../../../components/helpers/Translator";
import GGCLPlantListTab from "./GGCLPlantListTab";
import GGCLInformationTab from "./GGCLInformationTab";
import GGCLMassivePlantEditionTab from "./GGCLMassivePlantEditionTab";
import GGCLLegalTab from "./GGCLLegalTab";
import GGCLSanctionTab from "./GGCLSanctionTab";

export default function GGCLExpandedContainer(props) {
  const { obligationID, active } = props;
  const { moduleBridgeHex } = useParams();
  const permissions = useSelector(
    (state) => state.module[moduleBridgeHex].permissions,
  );
  const userBridgeSettings = useSelector(
    (s) => s.module?.[moduleBridgeHex]?.userBridge?.permissions,
  );
  const currentPage = useSelector((state) => state.currentPage);

  const [activeTab, setActiveTab] = useState(active || "plantList");

  return (
    <AppCard bodyClassName="p-0 mt-2">
      <Tabs
        navStyle={{ paddingBottom: "0.10rem" }}
        defaultActiveKey={activeTab}
        onSelect={(v) => setActiveTab(v)}
      >
        <Tab
          eventKey="plantList"
          title={ReactDOMServer.renderToString(
            <Translator
              file="module-globallegalCompliance"
              name="plant.list"
            />,
          )}
          tabClassName={`pt-3 ${activeTab === "plantList" ? "border border-bottom-0" : "border-0"} bg-white`}
        >
          <div className="p-3">
            <GGCLPlantListTab obligationID={obligationID} />
          </div>
        </Tab>
        <Tab
          eventKey="massivePlantEdition"
          title={ReactDOMServer.renderToString(
            <Translator
              file="module-globallegalCompliance"
              name="massive.plants.edition"
            />,
          )}
          tabClassName={`pt-3 ${activeTab === "massivePlantEdition" ? "border border-bottom-0" : "border-0"} bg-white`}
        >
          <div className="p-3">
            <GGCLMassivePlantEditionTab obligationID={obligationID} />
          </div>
        </Tab>
        <Tab
          eventKey="info"
          title={ReactDOMServer.renderToString(
            <Translator file="user" name="user.info" />,
          )}
          tabClassName={`pt-3 ${activeTab === "info" ? "border border-bottom-0" : "border-0"} bg-white`}
        >
          {activeTab === "info" && (
            <div className="p-3">
              <GGCLInformationTab obligationID={obligationID} />
            </div>
          )}
        </Tab>
        <Tab
          eventKey="legal"
          title={ReactDOMServer.renderToString(
            <Translator
              file="module-legalCompliance"
              name="module.lc.legal-reference"
            />,
          )}
          tabClassName={`pt-3 ${activeTab === "legal" ? "border border-bottom-0" : "border-0"} bg-white`}
        >
          {activeTab === "legal" && (
            <GGCLLegalTab obligationID={obligationID} />
          )}
        </Tab>
        {permissions?.ggcl?.sanction && (
          <Tab
            eventKey="sanction"
            title={ReactDOMServer.renderToString(
              <Translator
                file="user"
                name="user.obligations.location.penalty"
              />,
            )}
            className="p-3 bg-white"
          >
            {activeTab === "sanction" && (
              <div className="p-3">
                <GGCLSanctionTab obligationID={obligationID} />
              </div>
            )}
          </Tab>
        )}
      </Tabs>
    </AppCard>
  );
}
